import { Controller } from "stimulus"
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default class extends Controller {
  static targets = ['bookableContainer', 'bookableBox', 'bookableButton', 'closeButton']

  connect() {
    document.addEventListener("animationend", this.closeHandler.bind(this))

    if (document.getElementById("ba-widget").hasAttribute("open")) {
      this.showBookableBox()
    }
  }

  disconnect() {
    if (this.mobileScreenWidth) {
      clearAllBodyScrollLocks()
    }
  }

  showBookableBox() {
    this.bookableButtonTarget.classList.remove('fadeInUp', 'animated')
    this.bookableButtonTarget.style.display = 'none'
    this.bookableContainerTarget.classList.add('ba-container--visible')

    this.bookableBoxTarget.classList.remove('hidden', 'fadeOutDown')
    this.bookableBoxTarget.classList.add('fadeInUp')

    if (this.mobileScreenWidth) {
      disableBodyScroll(this.bookableBoxTarget)
    }
  }

  closeBookableBox() {
    this.bookableBoxTarget.classList.remove('fadeInUp')
    this.bookableBoxTarget.classList.add('fadeOutDown')

    this.bookableBoxTarget.addEventListener('animationend', (event) => {
      if (event.animationName == "fadeOutDown") {
        this.bookableBoxTarget.classList.add('hidden')

        //TODO: loop through all controllers and call reset() if function present
        this.stepsController.reset()
        this.servicesSelectorController.reset()
        // resetForm (except client-info)
        this.bookableContainerTarget.classList.remove('ba-container--visible')
        this.bookableButtonTarget.style.display = 'block'
        this.bookableButtonTarget.classList.add('animated')
        this.bookableButtonTarget.classList.add('fadeInUp')
      }
    })

    if (this.mobileScreenWidth) {
      enableBodyScroll(this.bookableBoxTarget)
    }
  }

  closeHandler(event) {
    this.bookableBoxTarget.classList.remove('fadeInUp', 'fadeOutDown')

    if (event.animationName == "fadeInUp") {
      this.bookableButtonTarget.classList.remove('fadeInUp', 'fadeOutDown')
    }
  }

  get mobileScreenWidth() {
    return window.screen.width <= 1400
  }

  get stepsController() {
    return this.getControllerByIdentifier("widget--steps")
  }

  get servicesSelectorController() {
    return this.getControllerByIdentifier("widget--services-selector")
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }
}
